// Stripe Buy Button configuration — single source of truth.
//
// A product enters embedded Stripe checkout when it has an entry in
// STRIPE_BUY_BUTTONS below. Each entry can either be:
//   - a plain string (buy-button-id), which uses STRIPE_PUBLISHABLE_KEY_DEFAULT, or
//   - an object { id, key } to override the publishable key for that button
//     (needed when a Buy Button lives in a different Stripe account or when
//      migrating a single product from test → live mode).
//
// The <script async src="https://js.stripe.com/v3/buy-button.js"></script>
// tag is loaded once in /app/frontend/public/index.html.

export const STRIPE_PUBLISHABLE_KEY_DEFAULT = process.env.REACT_APP_STRIPE_PK_TEST;

// Kept as an alias for backward-compat with any component that already
// imports STRIPE_PUBLISHABLE_KEY from this file.
export const STRIPE_PUBLISHABLE_KEY = STRIPE_PUBLISHABLE_KEY_DEFAULT;

// Per-product Buy Button configuration.
// Use the object form { id, key } when a button needs a non-default key.
export const STRIPE_BUY_BUTTONS = {
  // Pō Mahina — migrated to a new (LIVE-mode) Stripe account; uses its own key.
  "Pō Mahina Magnesium Recovery Spray": {
    id: "buy_btn_1U7nPdJcRv9YXJ9LJ5Vljsuy",
    key: process.env.REACT_APP_STRIPE_PK_LIVE,
  },
  // Lokahi — migrated to the same new LIVE-mode Stripe account.
  "Lokahi Yoga Mat Cleaner": {
    id: "buy_btn_1U7nR5JcRv9YXJ9Lwhzi7iOU",
    key: process.env.REACT_APP_STRIPE_PK_LIVE,
  },
  "Princess Pikake": "buy_btn_1U7lzmR9luLjnmw3ihCiaLuC",
  "Ka Lā 'Alohi": "buy_btn_1U7mhPR9luLjnmw3aUG6UQpB",
};

/**
 * Get the { buyButtonId, publishableKey } pair for a product, or null if the
 * product has no embedded Buy Button configured.
 */
export const stripeConfigFor = (name) => {
  const entry = STRIPE_BUY_BUTTONS[name];
  if (!entry) return null;
  if (typeof entry === "string") {
    return { buyButtonId: entry, publishableKey: STRIPE_PUBLISHABLE_KEY_DEFAULT };
  }
  return { buyButtonId: entry.id, publishableKey: entry.key || STRIPE_PUBLISHABLE_KEY_DEFAULT };
};

// Legacy helper — kept so existing imports don't break during migration.
export const buyButtonIdFor = (name) => stripeConfigFor(name)?.buyButtonId || null;
